/**
 * @name main.js
 * @author ychang
 *
 * */
require.config( {
    paths: {
        'gdaAudioTemplate': 'gameday-index-gdaAuth/src/templates',
        'text': 'requirejs-text/text'
    }
});

define('gameday-index-gdaAuth/src/main',['require','exports','module','jquery','es6ish-class/es6ish-class','requirejs-hogan-plugin/hogan','message-service/message-service','gameday-index-enums/enums/events/LoadEvents','gameday-index-enums/enums/events/OauthEvents','app-console/app-console','./GamedayAudioLogin'],function(require, module, exports) {

    var $ = require('jquery'),
        es6ishClass = require('es6ish-class/es6ish-class'),
        hogan = require('requirejs-hogan-plugin/hogan'),
        MessageService = require("message-service/message-service"),
        LoadEvts = require("gameday-index-enums/enums/events/LoadEvents"),
        OauthEvts = require("gameday-index-enums/enums/events/OauthEvents");
        logg = require("app-console/app-console"),
        GDLogin = require('./GamedayAudioLogin'),
        LOGIN_MODULE = new GDLogin.GamedayAudioLogin();

    var GamedayLoginIframe = es6ishClass(function(selectorString) {

        this.targetDivSelector = selectorString;
        this.currentStatus;

    });



    GamedayLoginIframe.define({

        targetDivSelector: "",

        checkOauthStatus: function() {

            if (this.currentStatus === OauthEvts.isNotLogin) {
                 LOGIN_MODULE.display();
            } else if (this.currentStatus === OauthEvts.isLogin) {
                LOGIN_MODULE.hide();
                MessageService.publish(OauthEvts.isLogin, this.componentID);
            }
        },

        init: function(config) {
            var that = this;
            var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
            var eventer = window[eventMethod];
            var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
            

            //$(this.targetDivSelector).hide().html(loginIframeTemplate.render());

            eventer(messageEvent, function(e) {
                if (e.data === OauthEvts.isNotLogin) {
                    that.currentStatus = OauthEvts.isNotLogin;
                    MessageService.publish(OauthEvts.isNotLogin, that.componentID);
                } else if (e.data === OauthEvts.userIsLoginUpsell) {
                    console.log("eventer userIsLoginUpsell");
                    that.currentStatus = OauthEvts.isLogin;
                } else if (e.data === OauthEvts.isLogin) {
                     console.log("eventer OauthEvts.isLogin");
                    that.currentStatus = OauthEvts.isLogin;
                    MessageService.publish(OauthEvts.isLogin, that.componentID);
                } else if (e.data === OauthEvts.loginHide) {
                    MessageService.publish(OauthEvts.loginHide, that.componentID);
                }
            }, false);


            MessageService.on(OauthEvts.checkOauthStatus, function() {
                that.checkOauthStatus.call(that);
            });
            
            MessageService.on(OauthEvts.isLoginNoEntitlement, function() {
               console.log("upsell");
               LOGIN_MODULE.displayUpsell();
            });
            
            
            
            LOGIN_MODULE.bind(LOGIN_MODULE.events.isLoggedIn, function(e, data) {

                if (!data.isLoggedIn) {
                    that.currentStatus = OauthEvts.isNotLogin;
                    window.postMessage(OauthEvts.isNotLogin, "*");
                } else {
                    console.log("LOGIN_MODULE is login")
                    that.currentStatus = OauthEvts.isLogin;
                    window.postMessage(OauthEvts.isLogin, "*");
                }

            }).bind("loginHide", function() {
                window.postMessage(OauthEvts.loginHide, "*");
            }).isLoggedIn({
                identify: true
            });
            LOGIN_MODULE.loadframe();
            

        }
    });

    return GamedayLoginIframe;
});
